import { z } from "zod";
import { IsoDateTime } from "./common.ts";

export const SpotifyApiLogKindSchema = z.enum(["web_api", "token"]);
export type SpotifyApiLogKind = z.infer<typeof SpotifyApiLogKindSchema>;

export const SpotifyApiLogEntrySchema = z.object({
  ts: IsoDateTime,
  seq: z.number().int().nonnegative(),
  day: z.string().min(1),
  day_count: z.number().int().nonnegative(),
  kind: SpotifyApiLogKindSchema,
  method: z.string().min(1),
  host: z.string().min(1),
  path: z.string().min(1),
  status: z.number().int(),
  ms: z.number().int().nonnegative(),
  ok: z.boolean(),
  retry_after: z.number().nullable(),
  quota_exceeded: z.boolean(),
  reason: z.string().nullable(),
  label: z.string().nullable(),
  retry: z.number().int().nonnegative(),
});

export type SpotifyApiLogEntry = z.infer<typeof SpotifyApiLogEntrySchema>;

export const SpotifyApiDayStatsSchema = z.object({
  day: z.string().min(1),
  calls: z.number().int().nonnegative(),
  web_api_calls: z.number().int().nonnegative(),
  by_status: z.record(z.string(), z.number().int().nonnegative()),
  last_seq: z.number().int().nonnegative(),
});

export type SpotifyApiDayStats = z.infer<typeof SpotifyApiDayStatsSchema>;

export const SpotifyApiLogTailSchema = z.object({
  entries: z.array(SpotifyApiLogEntrySchema),
  stats: SpotifyApiDayStatsSchema,
  log_path: z.string().min(1),
});

export type SpotifyApiLogTail = z.infer<typeof SpotifyApiLogTailSchema>;

/** How the local mirror was populated — connect ≠ sync. */
export const MirrorSourceSchema = z.enum(["empty", "offline_import", "live_sync"]);

export const MirrorInfoSchema = z.object({
  source: MirrorSourceSchema,
  note: z.string().min(1),
});

export type MirrorInfo = z.infer<typeof MirrorInfoSchema>;
